export default "__VITE_ASSET__Dq1Yj9Ry__"